import React from 'react';
import { Handle, Position } from 'reactflow';

const CircularNode = ({ data }) => {
  const isStart = data.label === 'Start';
  const isEnd = data.label === 'End' || data.label === 'Stop';
  const nodeSize = 60;
  const handleSize = 10;

  const glowColor = isStart ? 'rgba(76, 175, 80, 0.8)' : isEnd ? 'rgba(244, 67, 54, 0.8)' : 'rgba(33, 150, 243, 0.8)';

  return (
    <div className={`circular-node ${isStart ? 'start' : isEnd ? 'stop' : ''}`} style={{ position: 'relative', width: nodeSize, height: nodeSize }}>
      <div style={{ position: 'absolute', inset: -nodeSize / 2, borderRadius: '50%', background: `radial-gradient(circle, ${glowColor} 0%, rgba(255,255,255,0) 80%)`, filter: 'blur(15px)' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: '#fff', border: `3px solid ${isStart ? '#2e7d32' : isEnd ? '#c62828' : '#6a1b9a'}`, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 12, fontWeight: 700, color: '#333', boxShadow: '0 6px 18px rgba(106,27,154,0.15)' }}>
        {data.label}
        {!isEnd && (
          <Handle type="source" position={Position.Right} style={{ right: -handleSize / 2 - 2, width: handleSize, height: handleSize, background: '#1a192b', border: '2px solid #fff' }} />
        )}
        {!isStart && (
          <Handle type="target" position={Position.Left} style={{ left: -handleSize / 2 - 2, width: handleSize, height: handleSize, background: '#1a192b', border: '2px solid #fff' }} />
        )}
      </div>
    </div>
  );
};

export default CircularNode;
